import {
  endObjectConfigurationTrace,
  recordObjectConfigurationTraceEvent,
} from '@affine/core/modules/permissions/utils/object-configuration-trace';
import { ObjectPermissionDialogShell } from '@affine/core/modules/permissions/views/object-permission-dialog-shell';
import { useI18n } from '@affine/i18n';
import { type ReactNode, useEffect } from 'react';

import * as styles from './doc-configuration-dialog.css';
import { ShareMenuContent, type ShareMenuProps } from './share-menu/share-menu';

export interface DocConfigurationDialogProps extends ShareMenuProps {
  description?: ReactNode;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title?: string;
}

export const DocConfigurationDialog = ({
  description,
  open,
  onOpenChange,
  title,
  ...shareProps
}: DocConfigurationDialogProps) => {
  const t = useI18n();

  useEffect(() => {
    if (!open) {
      endObjectConfigurationTrace('doc', 'dialog-closed');
      return;
    }
    const frame = requestAnimationFrame(() => {
      recordObjectConfigurationTraceEvent('shell-visible');
    });
    return () => cancelAnimationFrame(frame);
  }, [open]);

  return (
    <ObjectPermissionDialogShell
      open={open}
      onOpenChange={onOpenChange}
      title={title ?? t['com.streamlain.share-menu.shareButton']()}
      confirmButtonOptions={{ style: { display: 'none' } }}
      cancelText={t['com.streamlain.folder-share.close']?.() ?? 'Close'}
    >
      <div className={styles.content} data-testid="doc-configuration-dialog">
        {description ? (
          <div className={styles.description}>{description}</div>
        ) : null}
        {open ? <ShareMenuContent {...shareProps} /> : null}
      </div>
    </ObjectPermissionDialogShell>
  );
};
